// LiveKit Configuration
// Dette er hardcoded for hurtig test - kan flyttes til .env senere

export const LIVEKIT_CONFIG = {
  // LiveKit Cloud URL fra backend team
  serverUrl: 'wss://voice-victor-z70ulnax.livekit.cloud',
  
  // Backend token endpoint (HTTPS certified API)
  tokenEndpoint: 'https://api.voicevictor.com:3001/api/livekit/token',
  
  // Backend scenarios endpoint (HTTPS certified API)
  scenariosEndpoint: 'https://api.voicevictor.com:3001/api/scenarios',
};

